import component from './nav-bar.component';

export default angular
  .module('fizyweb.paycell.navbar', [])
  .component('fizyPaycellNavBar', component).name;



// WEBPACK FOOTER //
// src/app/components/nav-bar/nav-bar.module.ts